import { render, staticRenderFns } from "./SeeRequests.vue?vue&type=template&id=310434bd&scoped=true"
import script from "./SeeRequests.vue?vue&type=script&lang=js"
export * from "./SeeRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310434bd",
  null
  
)

export default component.exports